/*
 * custom-perso-fix-variante-panier.js  (v1)  —  les Enfants Sauvages
 * ---------------------------------------------------------------------------
 * CORRIGE : « je choisis une senteur → le produit est ajouté 2 fois et
 *            2 paniers s'affichent »
 *
 * CAUSE (mesurée sur le site live le 18/08/2026) :
 *   Monster Cart intercepte le clic sur le bouton « Ajouter au panier » et
 *   fait l'ajout lui-même (c'est le fonctionnement normal : 1 seul ajout,
 *   1 seul tiroir). Or le thème Prestige RECRÉE ce bouton à chaque
 *   changement de variante (senteur). Monster ne se re-branche jamais sur le
 *   nouveau bouton — vérifié : après un changement de senteur, seul theme.js
 *   ré-enregistre des écouteurs, Monster aucun.
 *   Résultat : le clic déclenche l'ajout du THÈME (fetch) *et* celui de
 *   MONSTER (XHR, ~200 ms après) → 2 articles ; et le tiroir natif du thème
 *   s'ouvre par-dessus celui de Monster → « 2 paniers ».
 *
 * CE QUE FAIT CE SCRIPT :
 *   Il rebranche, sur les boutons RECRÉÉS uniquement, l'interception que
 *   Monster ne remet plus : il annule l'ajout du thème et redonne la main à
 *   Monster via sa propre fonction publique `monster_submitAddToCartForm`.
 *
 * CE QU'IL NE FAIT PAS (volontairement) :
 *   - Il ne touche PAS aux boutons présents au chargement de la page : ceux-là
 *     sont déjà gérés par Monster. On les marque et on les laisse tranquilles.
 *   - Il n'intercepte AUCUNE requête réseau (contrairement au garde-fou de
 *     juin 2026, qui réécrivait les appels /cart/add et s'était révélé
 *     instable). Aucun `fetch` ni `XMLHttpRequest` n'est modifié.
 *   - Il ne ferme ni ne masque aucun tiroir : le tiroir du thème ne s'ouvre
 *     tout simplement plus, puisque le thème n'ajoute plus.
 *
 * SÉCURITÉ / REPLI :
 *   - Si Monster est absent, désactivé ou renommé → le script ne fait RIEN et
 *     le thème reprend son comportement natif (aucun risque de panier bloqué).
 *   - Si un autre script a déjà intercepté le clic (`defaultPrevented`) → on
 *     s'abstient.
 *   - Si l'appel à Monster lève une erreur → repli automatique sur la
 *     soumission normale du formulaire (l'article est ajouté quand même).
 *
 * VALIDÉ EN DIRECT le 18/08/2026 sur /products/recharge-8-mois :
 *   - après changement de senteur : 1 seul /cart/add, 0 tiroir thème, panier
 *     à la bonne quantité (avant correctif : 2 /cart/add, tiroir thème ouvert,
 *     quantité doublée) ;
 *   - deuxième clic volontaire sur le même article : quantité passe bien à 2
 *     (les ajouts légitimes ne sont jamais bloqués) ;
 *   - bouton d'origine (sans changement de senteur) : non modifié.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  if (window.__lesFixVariantePanier) return;
  window.__lesFixVariantePanier = true;

  var SEL = 'product-form form[action*="/cart/add"] [type="submit"],' +
            'product-form form[action*="/cart/add"] button[name="add"]';

  function noop() {}

  function onClick(e) {
    var form = null;
    try {
      // Un autre acteur (Monster lui-même) a déjà pris la main : on ne fait rien.
      if (e.defaultPrevented) return;

      var submit = window.monster_submitAddToCartForm;
      if (typeof submit !== 'function') return; // Monster absent -> thème natif

      form = e.currentTarget.closest('form[action*="/cart/add"]');
      if (!form) return;

      // On rejoue exactement ce que fait Monster sur un bouton non recréé :
      // on empêche la soumission native (donc l'ajout du thème + son tiroir)
      // et on laisse Monster faire l'ajout.
      e.preventDefault();
      e.stopPropagation();

      submit({
        target: form,
        currentTarget: form,
        type: 'submit',
        preventDefault: noop,
        stopPropagation: noop,
        stopImmediatePropagation: noop
      });
    } catch (err) {
      // Repli : si Monster échoue, on laisse le thème ajouter normalement.
      try { if (form && form.requestSubmit) form.requestSubmit(); } catch (x) {}
    }
  }

  function armNew(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var list = scope.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (b.__lesSeen || b.__lesArmed) continue; // d'origine, ou déjà armé
      b.__lesArmed = true;
      b.addEventListener('click', onClick, false);
    }
  }

  function start() {
    // Boutons présents au chargement : ce sont ceux que Monster gère.
    var initial = document.querySelectorAll(SEL);
    for (var i = 0; i < initial.length; i++) initial[i].__lesSeen = true;

    if (!window.MutationObserver || !document.body) return;

    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var added = muts[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          armNew(node.parentElement || node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
